import {
	lph_1,
	lph_2,
	lph_3,
	lph_4,
	lph_5,
	lph_6,
	lph_7,
	lph_8,
} from '../assets/images/lph/images.js';

const options_lph = [
	{
		title: 'Как создать новую карточку главы ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейдите в Похозяйственную книгу, свод по которой хотите создать.',
				],
				image: lph_1.lph_1_1,
			},
			{
				text: ['4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.'],
				image: lph_1.lph_1_2,
			},
			{
				text: ['5. Нажать “Создать карточку главы ЛПХ”.'],
				image: lph_1.lph_1_3,
			},
			{
				text: ['6. Заполняем все необходимые данные.'],
				image: lph_1.lph_1_4,
			},
			{
				text: ['7. Нажать “Далее”. Карточка Главы ЛПХ создана.'],
				image: lph_1.lph_1_5,
			},
		],
	},
	{
		title: 'Как редактировать карточку главы ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно редактировать карточку Главы ЛПХ.',
				],
				image: lph_2.lph_2_1,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка карточку для редактирования.',
				],
				image: lph_2.lph_2_2,
			},
			{
				text: ['7. Нажмите на кнопку «Редактировать» в правом верхнем углу.'],
				image: lph_2.lph_2_3,
			},
			{
				text: [
					'8. Внесите изменения в появившемся окне формы карточки.',
					'9. Нажмите на кнопку «Сохранить» в правом верхнем углу.',
				],
				image: lph_2.lph_2_4,
			},
			{
				text: ['10. Изменения сохранены.'],
			},
		],
	},
	{
		title: 'Как добавить дополнительный лицевой счет в карточку главы ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно добавить дополнительный лицевой счет.',
				],
				image: lph_3.lph_3_1,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выберите из списка карточку Главы ЛПХ для добавление дополнительного лицевого счета.',
				],
				image: lph_3.lph_3_2,
			},
			{
				text: ['7. Нажмите на кнопку «Редактировать» в правом верхнем углу.'],
				image: lph_3.lph_3_3,
			},
			{
				text: ['8. Нажмите “Создать ЛС”.'],
				image: lph_3.lph_3_4,
			},
			{
				text: [
					'9. Если есть Основной лицевой счет, то новый будет автоматически добавлен как “Дополнительный” в противном случае выберите “Дополнительный”.',
					'10. Заполняем все необходимые данные.',
					'11. Нажмите на кнопку «Сохранить» в правом верхнем углу.',
				],
				image: lph_3.lph_3_5,
			},
			{
				text: ['12. Изменения сохранены.'],
			},
		],
	},
	{
		title: 'Как передать полномочия главы ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно передать полномочия главы ЛПХ.',
				],
				image: lph_4.lph_4_1,
			},
			{
				text: [
					'4. Перейдите в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
					'6. Выбрать из списка Глав ЛПХ карточку, с которой нужно сложить полномочия Главы ЛПХ.',
				],
				image: lph_4.lph_4_2,
			},
			{
				text: ['7. Нажимаем “Передать полномочия главы ЛПХ”.'],
				image: lph_4.lph_4_3,
			},
			{
				text: [
					'8. Заполняем необходимые данные нового главы ЛПХ.',
					'9. Нажимаем “Передать полномочия”.',
				],
				image: lph_4.lph_4_4,
			},
			{
				text: ['10. Изменения сохранены.'],
				image: lph_4.lph_4_5,
			},
		],
	},
	{
		title: 'Как посмотреть карточки ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Карточки ЛПХ» в левом боковом меню.',
					'3. На экране появится список карточек ЛПХ.',
				],
				image: lph_5.lph_5_1,
				label: true,
			},
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно посмотреть карточки ЛПХ.',
				],
				image: lph_5.lph_5_2,
			},
			{
				text: [
					'4. Перейти в раздел “Карточки ЛПХ” в верхней части раздела.',
					'5. На экране появится список Карточек ЛПХ.',
				],
				image: lph_5.lph_5_3,
			},
		],
	},
	{
		title: 'Как посмотреть реестр глав ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Реестр глав ЛПХ» в левом боковом меню.',
					'3. На экране появится реестр глав ЛПХ.',
				],
				image: lph_6.lph_6_1,
				label: true,
			},
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно посмотреть глав ЛПХ.',
				],
				image: lph_6.lph_6_2,
			},
			{
				text: [
					'4. Перейти в раздел “Главы ЛПХ” в верхней части раздела.',
					'5. На экране появится список Глав ЛПХ.',
				],
				image: lph_6.lph_6_3,
			},
		],
	},
	{
		title: 'Как создать новую карточку ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно создать новую карточку ЛПХ.',
				],
				image: lph_7.lph_7_1,
			},
			{
				text: [
					'4. Перейти в раздел “Карточки ЛПХ” в верхней части раздела.',
					'5. Нажмите “Создать карточку”.',
				],
				image: lph_7.lph_7_2,
			},
			{
				text: [
					'6. Выбрать главу ЛПХ, для которого создается карточка.',
					'7. Нажмите  “Продолжить”.',
				],
				image: lph_7.lph_7_3,
			},
			{
				text: [
					'8. В открывшемся окне выберите период («Ежегодный» – для годовой карточки ЛПХ, «Уточнение сведений» – для карточки ЛПХ на дату уточнения сведений) и статус карточки («Действующее» – для действующего ЛПХ, «Заброшенное» – для заброшенного ЛПХ).',
					'9. Нажмите на кнопку «Сохранить».',
				],
				image: lph_7.lph_7_4,
			},
			{
				text: [
					'10. Карточка создана и готова к заполнению. Разделы для заполнения карточки отображены в левом боковом меню.',
					'11. Перейдите в раздел «Члены хозяйства». Нажмите на кнопку «Добавить члена хозяйства» и заполните реквизиты членов хозяйства.',
					'12. Нажмите на кнопку «Сохранить» после заполнения всех полей.',
				],
				image: lph_7.lph_7_5,
			},
			{
				text: [
					'13. Перейдите в раздел «Земельные участки». Заполните все необходимые поля. При необходимости указания сведений по дополнительному лицевому счету нажмите на кнопку «Добавить лицевой счет».',
					'14. Нажмите на кнопку «Сохранить» после заполнения всех полей.',
					'15. Заполните аналогично предыдущему разделу остальные разделы: «СХ Животные», «СХ Техника», «Домовладение», «Растениеводство», «Животноводство» «Экономика», «СПоК».',
				],
				image: lph_7.lph_7_6,
			},
			{
				text: [
					'16. Перейдите в раздел «Изменения». Заполните все необходимые поля.',
					'17. Нажмите на кнопку «Прикрепить согласие» и прикрепите скан-копии согласия со сведениями, внесенными в похозяйственную книгу.',
					'18. Нажмите на кнопку «Сохранить».',
					'19. Карточка ЛПХ заполнена и находится в разделе «Карточки ЛПХ».',
				],
				image: lph_7.lph_7_7,
			},
		],
	},
	{
		title: 'Как редактировать карточку ЛПХ',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейти в Похозяйственную книгу, в которой нужно изменить карточку ЛПХ',
				],
				image: lph_8.lph_8_1,
			},
			{
				text: [
					'4. Перейти в раздел “Карточки ЛПХ” в верхней части раздела.',
					'5. Выберите из списка карточку для редактирования.',
				],
				image: lph_8.lph_8_2,
			},
			{
				text: [
					'6. Внесите изменения в необходимых разделах карточки ЛПХ.',
					'7. Нажмите на кнопку «Сохранить» в правом верхнем углу.',
					'8. Изменения сохранены.',
				],
				image: lph_8.lph_8_3,
			},
		],
	},
];

export default options_lph;
